<template>
  <div>
    <option-bundle-popup
      v-if="popupRendered && lastRuleCheckContext"
      :visible.sync="popupVisible"
      :last-rule-check-context="lastRuleCheckContext"
      :enable-pad-option-detail="enablePadOptionDetail"
      @confirm="handleConfirm"
    />
  </div>
</template>

<script setup>
import {
  concatOptionsList,
  useGlobalStore,
  useModalsStore,
  useRuleCheckStore,
} from 'shared'

import OptionBundlePopup from './index.vue'

defineProps({
  enablePadOptionDetail: {
    type: Boolean,
    default: true,
  },
})

const modalsStore = useModalsStore()
const ruleCheckStore = useRuleCheckStore()
const globalStore = useGlobalStore()

const popupRendered = ref(false)
const popupVisible = computed({
  get: () => modalsStore.showBundlePopup,
  set: (visible) => modalsStore.toggleBundlePopup(visible),
})

const lastRuleCheckContext = computed(() => {
  if (!ruleCheckStore.lastRequest || !ruleCheckStore.lastResponse) {
    return null
  }
  return {
    request: ruleCheckStore.lastRequest,
    response: ruleCheckStore.lastResponse,
  }
})

watch(
  popupVisible,
  (visible) => {
    if (visible) {
      popupRendered.value = true
      return
    }
    setTimeout(() => {
      popupRendered.value = false
    }, 400)
  },
  {
    immediate: true,
  }
)

const handleConfirm = async (resultOptionList = []) => {
  let configs = resultOptionList.map((item) => ({
    featureCode: item.feature_code,
    code: item.code,
    selected: true,
  }))

  if (configs.length) {
    const currentOptionsList = globalStore.currentOptionList.map((item) => ({
      featureCode: item.feature_code,
      code: item.code,
      selected: true,
    }))
    configs = concatOptionsList(configs, currentOptionsList)
  }

  await globalStore.batchUpdateConfig(configs, null, false)
  modalsStore.notifyBundlePopupConfirm()
  popupVisible.value = false
}
</script>
